import * as React from "react";
import FilteredBackgroundTasks from "./FilteredBackgroundTasks";

interface Props {
    documentId: string;
    breadcrumbTitle: string;
    breadcrumbChip?: JSX.Element;
}

class RelatedBackgroundTasks extends React.Component<Props> {

    private filteredBackgroundTasks = React.createRef<FilteredBackgroundTasks>(); 
    
    constructor(props: Props) {
        super(props);
    }   

    render() {
        const excludeRecurring: boolean = true;

        return <FilteredBackgroundTasks 
                ref={this.filteredBackgroundTasks}
                breadcrumbTitle={this.props.breadcrumbTitle}
                breadcrumbChip={this.props.breadcrumbChip}
                documentId={this.props.documentId}
                excludeRecurring={excludeRecurring} 
        ></FilteredBackgroundTasks>;
    }
}

export default RelatedBackgroundTasks;